@if (!isProcessing) {
  <div>
    @if (show) {
      <div
        id="snackbar"
        style="background-color: #a59800; z-index: 100000; position: relative"
        class="show"
        >
        {{ message }}
      </div>
    }
    @if (!isBankAllowed) {
      <div class="form-group">
        <div class="flex-container">
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            (change)="setSelectedBank($event.target.value)"
            >
            <option>Select MOMO Provider</option>
            <option value="MTN">MTN</option>
            <option value="AIRTEL">AirtelTigo</option>
            <option value="VODAFONE">VODAFONE</option>
          </select>
        </div>
        <div class="flex-container">
          <input
            [(ngModel)]="momoNumber"
            style="width: 100%; margin-top: 10%"
            class="form-control"
            id="PhoneNumber"
            type="text"
            required
            placeholder=" "
            />
            <label for="PhoneNumber">Phone Number*</label>
          </div>
          <div class="form_button">
            <button
              [disabled]="!(bankName && momoNumber)"
              (click)="generateUSSD()"
              type="button"
              id="pay-button"
              style="width: 100%; margin-top: 20%"
              >
              Pay GHS {{ ussdPaymentRequest.amount }}
            </button>
          </div>
        </div>
      }
      @if (isBankAllowed) {
        <div class="ussd_code">
          <div>
            <p style="font-size: 13px; text-align: center; margin-top: 5%">
              {{ bankName }} <br />
              <!-- <i style="color: #950007;"
              >Txn. Ref: {{ ussdPaymentRequest.reference }}</i
              > -->
              <br />
              <!-- Dial the following code on your mobile phone to make payment -->
            </p>
            <p
        style="
          color:green;
          font-size: 30px;
          text-align: center;
          font-weight: bolder;
        "
              >
              {{ ussdPaymentRes.providerResponse }}
            </p>
            <br />
          </div>
          <div style="font-size: 13px; text-align: center; margin-top: 5%">
            <button
              (click)="checkPaymentStatus()"
              type="button"
              id="pay-button"
              style="margin-top: 5%; margin-bottom: -10%"
              class="btn btn-lg btn-block checkout_form-button"
              >
              Check Transaction Status
            </button>
          </div>
          <div
            class="row checkout_form-row button-container"
            style="margin-top: 20%"
          ></div>
        </div>
      }
    </div>
  }

  @if (isProcessing) {
    <div class="text-center">
      <div
        class="spinner-border spinner-border"
        style="width: 6rem; height: 6rem; color: green"
        role="status"
        >
        <span class="sr-only">Loading...</span>
      </div>
      <br /><br />
      <p style="color: black">Processing Payment</p>
    </div>
  }
